import { env } from "@/env";

export type AISpeechClassifierResponseModel = {
  probability: number;
};

export const classifyAISpeech = async (file: File): Promise<AISpeechClassifierResponseModel> => {
  const formData = new FormData();
  formData.append("file", file);
  const url = `${env.NEXT_PUBLIC_XI_SERVER_URL}/v1/moderation/ai-speech-classification`;
  const response = await fetch(url, {
    method: "POST",
    body: formData,
  });

  if (response.status !== 200) {
    const body = await response.json();
    throw new Error(body?.detail?.message || "Failed to classify AI speech, please try again later");
  }
  const body: AISpeechClassifierResponseModel = await response.json();
  return body;
};
